// IE 2026 11 03 / ODOO-5800 (ie-dm7 #128579: согласование правил MAP-*, этап C)
// Чистые функции согласования правил карт MAP-* (контракт бэка — ie-dm7 plan.md §7, PR #980: rule_approval_state / _approve / _reject / _request / _withdraw):
// включение (флаг fe.ux.ruleApproval + настройка списка doc.params.approval.rules), разбор state / summary, пилюля строки, кнопка сводки с меню команд,
// действие с окном подтверждения (список правил, комментарий), тексты отказов, блок отличий «було → стало», история для окна History. Без Vue и DOM.
// Проводка: AttrGrid.ruleApproval_* (список), Widget.ruleApproval_form* (форма правила), RuleApprovalForm.vue (окно формы). Тест — tests/unit/ruleApproval.test.mjs
import { t } from '@/i18n'

export const RULE_APPROVAL_FLAG = 'fe.ux.ruleApproval'
export const STATUS_SEGMENT = 'STATUS-rule'
export const METHODS = { state: 'rule_approval_state', approve: 'rule_approval_approve', reject: 'rule_approval_reject', request: 'rule_approval_request', withdraw: 'rule_approval_withdraw' }
export const ACTIONS = ['request', 'approve', 'reject', 'withdraw']
export const COMMENT_REQUIRED = ['reject', 'withdraw']
export const ST = { pending: 'statusRule-pending', approved: 'statusRule-approved', changed: 'statusRule-changed', rejected: 'statusRule-rejected' }
export const STATUSES = [ST.pending, ST.approved, ST.changed, ST.rejected]
export const LIMIT = 2000   // правил в одном вызове state (видимые строки списка)

const isObj = (x) => !!(x && typeof x === 'object' && !Array.isArray(x))
const str = (v) => (v === undefined || v === null) ? '' : String(v).trim()
const _esc = (v) => String(v === undefined || v === null ? '' : v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')

// ----- включение -----
// IE 2026 11 03 / ODOO-5800 (webscm #128969: блокер выката — форма согласования правил по умолчанию выключена):
// флаг fe.ux.ruleApproval: дефолт ВЫКЛ, включает только явный true; читать нечем — ВЫКЛ (planApproval_on с 04.11 — дефолт ВКЛ, здесь без изменений)   // IE 2026 11 04 / ODOO-5800 (слово Игоря через ie-dm7 #129874: дефолт ВКЛ; замок v2 — why из may_decide)
export const RULE_APPROVAL_DEFAULT = false   // IE 2026 11 03 / ODOO-5800 (webscm #128969: блокер выката — форма согласования правил по умолчанию выключена)
export function ruleApproval_on(setting) {
    try { return typeof setting === 'function' ? setting(RULE_APPROVAL_FLAG, RULE_APPROVAL_DEFAULT) === true : RULE_APPROVAL_DEFAULT } catch (e) { return RULE_APPROVAL_DEFAULT }   // IE 2026 11 03 / ODOO-5800 (webscm #128969: блокер выката — форма согласования правил по умолчанию выключена)
}
// настройка виджета списка: doc.params.approval.rules (truthy)
export function ruleApproval_listEnabled(doc) {
    const ap = isObj(doc) && isObj(doc.params) ? doc.params.approval : null
    return !!(isObj(ap) && ap.rules)
}
export function ruleApproval_isMap(segment) { return /^MAP-/.test(str(segment)) }

// ----- статусы -----
const SHORT = { [ST.pending]: 'pending', [ST.approved]: 'approved', [ST.changed]: 'changed', [ST.rejected]: 'rejected' }
export function ruleApproval_status(x) { const s = str(x); return STATUSES.includes(s) ? s : ST.pending }
// записи справочника STATUS-rule (itemsSource: {data: [...]} | [...]) → {id: {title, cssClass}}
export function ruleApproval_statusRecs(src) {
    const list = Array.isArray(src) ? src : (isObj(src) && Array.isArray(src.data) ? src.data : [])
    const out = {}
    for (const r of list) if (isObj(r) && str(r.id)) out[str(r.id)] = { title: str(r.title), cssClass: str(r.cssClass || r.doc?.cssClass) }
    return out
}
export function ruleApproval_statusText(status, recs = null) {
    const s = ruleApproval_status(status), r = isObj(recs) ? recs[s] : null
    if (r && r.title) return r.title   // справочник уже на языке пользователя
    switch (s) {
        case ST.approved: return t('Approved')
        case ST.changed: return t('Changed after approval')
        case ST.rejected: return t('Rejected')
        default: return t('Not approved')
    }
}
// класс цвета: cssClass записи статуса, иначе свой тон ra-tone-*
export function ruleApproval_tone(status, recs = null) {
    const s = ruleApproval_status(status), r = isObj(recs) ? recs[s] : null
    return (r && r.cssClass) ? r.cssClass : 'ra-tone-' + SHORT[s]
}

// ----- разбор ответа rule_approval_state -----
function _row(r, recs) {
    const status = ruleApproval_status(r.status)
    return { rule: str(r.rule), status, storedStatus: str(r.stored_status), text: ruleApproval_statusText(status, recs), tone: ruleApproval_tone(status, recs),
        changed: status === ST.changed, ruleGone: r.rule_gone === true, approvedAt: str(r.approved_at), approvedBy: str(r.approved_by),
        diff: (Array.isArray(r.diff) ? r.diff : []).filter(isObj), diffFields: (Array.isArray(r.diff_fields) ? r.diff_fields : []).map(str).filter(Boolean),
        owner: str(r.owner), ownerVia: str(r.owner_via), ownerRole: str(r.owner_role), canApprove: r.can_approve === true, record: str(r.record),
        comment: str(r.comment), history: (Array.isArray(r.history) ? r.history : []).filter(isObj) }
}
export function ruleApproval_summary(raw) {
    if (!isObj(raw)) return null
    const counts = {}
    for (const s of STATUSES) counts[s] = Math.max(0, Number(raw[s]) || 0)
    return { total: Math.max(0, Number(raw.total) || 0), counts }
}
// answer.rule_approval → {off, segment, version, policy, rows: {rule: row}, list: [row], summary}; null — ответа нет
export function ruleApproval_state(raw, recs = null) {
    if (!isObj(raw)) return null
    if (raw.off === true) return { off: true, segment: '', version: '', policy: null, rows: {}, list: [], summary: null }
    const list = (Array.isArray(raw.rows) ? raw.rows : []).filter(r => isObj(r) && str(r.rule)).map(r => _row(r, recs))
    const rows = {}
    for (const r of list) rows[r.rule] = r
    return { off: false, segment: str(raw.segment), version: str(raw.version), policy: isObj(raw.policy) ? raw.policy : null, rows, list, summary: ruleApproval_summary(raw.summary) }
}
// согласование показывается: ответ есть, не выключен, у карты есть политика
export function ruleApproval_visible(st) { return !!(isObj(st) && !st.off && st.policy) }
// свежие строки (ответ actions_after / повторный state) — поверх кэша
export function ruleApproval_merge(st, fresh) {
    if (!isObj(st)) return fresh
    if (!isObj(fresh) || fresh.off) return fresh || st
    const rows = { ...st.rows, ...fresh.rows }
    return { ...st, policy: fresh.policy || st.policy, rows, list: Object.values(rows), summary: fresh.summary || st.summary }
}

// ----- пилюля строки списка (колонка-название) -----
export function ruleApproval_pillHtml(row, escape = _esc) {
    if (!isObj(row)) return ''
    const mark = row.changed ? `<i class="pi pi-exclamation-circle ra-changed"></i>` : ''
    return `<span class="status-chip ra-pill ${escape(row.tone)}" data-ra-status="${escape(row.status)}">${mark}${escape(row.text)}</span>`
}
export function ruleApproval_pillTip(row) {
    if (!isObj(row)) return ''
    const parts = [row.text]
    if (row.changed) parts.push(t('changed after approval') + (row.diffFields.length ? ': ' + row.diffFields.join(', ') : ''))
    if (row.approvedBy || row.approvedAt) parts.push(t('Approved by {who} at {at}', { who: row.approvedBy || '—', at: ruleApproval_atText(row.approvedAt) || '—' }))
    return parts.join(' · ')
}
export function ruleApproval_atText(v) {
    const m = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/.exec(str(v))
    return m ? m[3] + '.' + m[2] + '.' + m[1] + ' ' + m[4] + ':' + m[5] : str(v)
}

// IE 2026 11 03 / ODOO-5800 (ie-dm7 #128579: согласование правил MAP-*, этап C — правки пробы p246):
// колонка пилюли статуса в списке правил: в «Purchasing rules» колонка title — 48 px, пилюля за текстом не видна. Порядок выбора среди видимых
// не булевых колонок: title / name / code шириной от PILL_MIN_W; иначе первая шириной от PILL_WIDE_W (место и пилюле, и тексту), иначе от PILL_MIN_W;
// иначе title / name / code любой ширины, иначе первая видимая. cols — [{binding, visible, width, bool}] в порядке колонок грида; ответ — индекс колонки
export const PILL_MIN_W = 90
export const PILL_WIDE_W = 160
export function ruleApproval_pillColIndex(cols) {
    const vis = (Array.isArray(cols) ? cols : []).map((c, i) => ({ i, b: str(c?.binding), w: Number(c?.width) || 0, ok: c?.visible !== false && !c?.bool })).filter(c => c.ok)
    if (!vis.length) return 0
    const named = (n) => (c) => new RegExp('(^|\\.)' + n + '$').test(c.b)
    for (const n of ['title', 'name', 'code']) { const c = vis.find(x => x.w >= PILL_MIN_W && named(n)(x)); if (c) return c.i }
    const c = vis.find(x => x.w >= PILL_WIDE_W) || vis.find(x => x.w >= PILL_MIN_W) || vis.find(x => ['title', 'name', 'code'].some(n => named(n)(x))) || vis[0]
    return c.i
}

// ----- кнопка сводки и меню -----
// подписи счётчиков (короткие), порядок — как в сводке
export function ruleApproval_counters(summary) {
    if (!isObj(summary)) return []
    return STATUSES.filter(s => summary.counts[s] > 0).map(s => ({ status: s, n: summary.counts[s], tone: ruleApproval_tone(s), text: ruleApproval_statusText(s) }))
}
export function ruleApproval_headerHtml(summary) {
    const c = ruleApproval_counters(summary).map(x => `<span class="ra-cnt ${_esc(x.tone)}" data-ra-status="${_esc(x.status)}">${_esc(x.n)}</span>`).join('')
    return `<span class="ra-hdr"><i class="pi pi-verified ra-hdr-icon"></i><span class="ra-hdr-label">${_esc(t('Approval'))}</span>${c}<i class="pi pi-angle-down ra-hdr-caret"></i></span>`
}
export function ruleApproval_summaryText(summary) {
    const c = ruleApproval_counters(summary)
    if (!isObj(summary)) return t('Loading…')
    return t('Rules: {n}', { n: summary.total }) + (c.length ? ' · ' + c.map(x => x.text + ' ' + x.n).join(' · ') : '')
}
export function ruleApproval_actionTitle(action) {
    switch (action) {
        case 'request': return t('Request approval')
        case 'approve': return t('Approve')
        case 'reject': return t('Reject')
        case 'withdraw': return t('Withdraw approval')
        default: return t('History')
    }
}
const ICON = { request: 'pi-send', approve: 'pi-check', reject: 'pi-times', withdraw: 'pi-undo', history: 'pi-history' }
// может ли пользователь утвердить выбранные: у каждой известной строки can_approve; неизвестных (ещё нет в кэше) не считаем
export function ruleApproval_canApprove(st, ids) {
    const rows = (Array.isArray(ids) ? ids : []).map(id => st?.rows?.[str(id)]).filter(Boolean)
    return rows.length > 0 && rows.every(r => r.canApprove)
}
// меню кнопки (AttrMenu панели грида); st — ruleApproval_state | null (загрузка); ctx {source_name, binding, selected: [id]}
export function ruleApproval_menu(st, ctx = {}) {
    const base = { name: 'button-rule-approval-menu', attr_type: 'AttrMenu', autoGeneratedButton: true, showCommandTitle: true, uiHelp: 'ruleApproval.menu', title: t('Approval'), tooltip: t('Approval') }
    const item = (o) => { const a = { attr_type: 'AttrButton', command: 'executeVueObjMethod', method: 'ruleApproval_run', ...o }
        if (str(ctx.source_name)) a.source_name = ctx.source_name
        if (str(ctx.binding)) a.binding = ctx.binding
        return a }
    if (!isObj(st)) return { ...base, cssClass: 'ra-btn', headerHtml: ruleApproval_headerHtml(null), uiHelpNow: t('Loading…'), attrs: [{ name: 'button-ra-loading', attr_type: 'AttrButton', title: t('Loading…'), disabled: true }] }
    const anyOwner = st.list.some(r => r.canApprove)
    const attrs = [{ name: 'button-ra-head', attr_type: 'AttrButton', title: ruleApproval_summaryText(st.summary), disabled: true, cssClass: 'ra-menu-head' }]
    // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128579: согласование правил MAP-*, этап C — правки пробы p246): AttrMenu / store.formatMenuItem не понимают disabled у команды (Approve выглядел активным) —
    // как у утверждения планов (planApproval_menu, mayDecide=false): нет права — команда Approve скрыта, вместо неё одна строка-причина без команды
    if (!anyOwner) attrs.push({ name: 'button-ra-noright', attr_type: 'AttrButton', title: t('Only the rule owner from the responsibles register can approve'), disabled: true, cssClass: 'ra-menu-noright' })   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128579: согласование правил MAP-*, этап C — правки пробы p246)
    for (const a of ACTIONS) {
        if (a === 'approve' && !anyOwner) continue   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128579: согласование правил MAP-*, этап C — правки пробы p246)
        attrs.push(item({ name: 'button-ra-' + a, title: ruleApproval_actionTitle(a), cssClass: 'pi p-button-white ' + ICON[a], ra_action: a, uiHelp: 'ruleApproval.cmd.' + a }))   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128579: согласование правил MAP-*, этап C — правки пробы p246): без disabled / tooltip
    }
    attrs.push({ title: '-' })
    attrs.push(item({ name: 'button-ra-history', title: t('History'), cssClass: 'pi p-button-white ' + ICON.history, ra_action: 'history', uiHelp: 'ruleApproval.cmd.history' }))
    return { ...base, cssClass: 'ra-btn', headerHtml: ruleApproval_headerHtml(st.summary), uiHelpNow: ruleApproval_summaryText(st.summary), attrs }
}

// ----- команда: окно подтверждения со списком правил и комментарием -----
export function ruleApproval_listText(ids, titleOf = null, max = 10) {
    const list = (Array.isArray(ids) ? ids : []).map(str).filter(Boolean)
    const name = (id) => (typeof titleOf === 'function' && str(titleOf(id))) || id
    const lines = list.slice(0, max).map(id => '• ' + name(id))
    if (list.length > max) lines.push(t('… and {n} more', { n: list.length - max }))
    return lines.join('\n')
}
export function ruleApproval_confirmText(action, ids, titleOf = null) {
    const n = (Array.isArray(ids) ? ids : []).length
    const head = action === 'approve' ? t('Approve {n} rule(s): the current values become the approved snapshot.', { n })
        : action === 'reject' ? t('Reject {n} rule(s). A comment is required.', { n })
            : action === 'withdraw' ? t('Withdraw the approval of {n} rule(s): they return to Not approved. A comment is required.', { n })
                : t('Request the approval of {n} rule(s) from the rule owner.', { n })
    return head + '\n' + ruleApproval_listText(ids, titleOf)
}
// проверка до отправки: '' — можно; иначе текст предупреждения
export function ruleApproval_validate(action, ids, st) {
    if (!ACTIONS.includes(action)) return ruleApproval_codeText('unknown_action')
    if (!(Array.isArray(ids) && ids.length)) return ruleApproval_codeText('no_selection')
    if (action === 'approve' && st && !ruleApproval_canApprove(st, ids)) return t('Only the rule owner from the responsibles register can approve')
    return ''
}
// действие store.executeStoreMethod: метод виджета + params.rules явно + окно (confirm_input: комментарий; обязателен у reject / withdraw)
export function ruleApproval_action(action, target = {}, ctx = {}) {
    const ids = (Array.isArray(target.rules) ? target.rules : []).map(str).filter(Boolean)
    const params = { rules: ids }
    if (str(target.segment)) params.segment = str(target.segment)
    if (target.version !== undefined && target.version !== null) params.version = str(target.version)
    const a = { name: 'button-ra-' + action, title: ruleApproval_actionTitle(action), command: 'executeWidgetMethod', method: METHODS[action], params,
        record_sendToBackend_exclude: ['_doc'], widget_sendToBackend_exclude: ['view'], no_del_last_backend_action: true,
        confirm: ruleApproval_confirmText(action, ids, ctx.titleOf),
        confirm_input: { field: 'comment', label: t('Comment'), value: '', required: COMMENT_REQUIRED.includes(action) } }
    if (str(ctx.source_name)) a.source_name = ctx.source_name
    if (str(ctx.binding)) a.binding = ctx.binding
    return a
}

// ----- ответ записи -----
export function ruleApproval_codeText(code, fallback = '') {
    switch (str(code)) {
        case 'no_selection': return t('Select the rules first')
        case 'no_policy': return t('The rules of this map are not approved (no rule approval policy)')
        case 'unknown_action': return t('Unknown action')
        case 'comment_required': return t('A comment is required')
        case 'rule_gone': return t('The rule is no longer in the map')
        case 'already_approved': return t('Already approved without changes')
        case 'already_requested': return t('Approval is already requested')
        case 'not_approved': return t('The rule is not approved')
        case 'no_user': return t('The user is not known: sign in again')
        case 'not_owner': return t('Only the rule owner from the responsibles register can do this')
        case 'behalf_comment': return t('An administrator acts on behalf of the rule owner only with a comment')
        case 'write_failed': return t('Not saved: {text}', { text: str(fallback) || t('database error') })
        default: return str(fallback) || str(code)
    }
}
// answer.rule_approval (approve / …) → {ok, total, off, refused: [{rule, code, text}], message, status}
export function ruleApproval_result(raw, titleOf = null) {
    if (!isObj(raw)) return { ok: 0, total: 0, off: false, refused: [], message: t('No answer from the server'), status: 'warning' }
    if (raw.off === true) return { ok: 0, total: 0, off: true, refused: [], message: t('Rule approval is switched off'), status: 'warning' }
    const name = (id) => (typeof titleOf === 'function' && str(titleOf(id))) || id
    const refused = (Array.isArray(raw.refused) ? raw.refused : []).filter(isObj).map(r => ({ rule: str(r.rule), code: str(r.code), text: ruleApproval_codeText(r.code, r.text) }))
    const ok = Number(raw.ok) || 0, total = Number(raw.total) || 0
    let message = t('{action}: {ok} of {total}', { action: ruleApproval_actionTitle(str(raw.action)), ok, total })
    if (refused.length) message += '\n' + refused.slice(0, 10).map(r => (r.rule ? name(r.rule) + ' — ' : '') + r.text).join('\n') + (refused.length > 10 ? '\n' + t('… and {n} more', { n: refused.length - 10 }) : '')
    return { ok, total, off: false, refused, message, status: refused.length ? (ok ? 'warning' : 'error') : 'success' }
}
// actions_after бэка: вызов rule_approval_state (params как пришли); null — нет
export function ruleApproval_afterState(answer) {
    const list = isObj(answer) && Array.isArray(answer.actions_after) ? answer.actions_after : []
    const a = list.find(x => isObj(x) && x.command === 'executeWidgetMethod' && x.method === METHODS.state)
    return a ? { method: a.method, params: isObj(a.params) ? { ...a.params } : {} } : null
}

// ----- блок отличий формы правила -----
// заголовки полей: колонки / атрибуты с binding 'doc.<поле>' → title (в глубину attrs / columns)
export function ruleApproval_fieldTitles(src, out = {}, depth = 0) {
    if (depth > 12 || !src) return out
    if (Array.isArray(src)) { for (const x of src) ruleApproval_fieldTitles(x, out, depth + 1); return out }
    if (!isObj(src)) return out
    const b = str(src.binding), title = str(src.title || src.header)
    const m = /^doc\.([A-Za-z0-9_]+)$/.exec(b)
    if (m && title && !out[m[1]]) out[m[1]] = title
    for (const k of ['attrs', 'columns', 'tabs']) if (src[k]) ruleApproval_fieldTitles(src[k], out, depth + 1)
    return out
}
export function ruleApproval_valueText(v) {
    if (v === undefined || v === null || v === '') return '—'
    if (v === true) return t('Yes')
    if (v === false) return t('No')
    if (Array.isArray(v)) return v.length ? v.map(ruleApproval_valueText).join(', ') : '—'
    if (isObj(v)) { try { return JSON.stringify(v) } catch (e) { return String(v) } }
    return String(v)
}
const GONE = '<rule deleted>'
export function ruleApproval_diffRows(diff, titles = {}) {
    return (Array.isArray(diff) ? diff : []).filter(isObj).map(d => {
        const f = str(d.field)
        if (f === GONE) return { field: f, title: t('The rule is deleted from the map'), approved: '', current: '', gone: true }
        return { field: f, title: (isObj(titles) && str(titles[f])) || f, approved: ruleApproval_valueText(d.approved), current: ruleApproval_valueText(d.current), gone: false }
    })
}
// модель окна формы правила: row (ruleApproval_state) → {status, text, tone, changed, approvedAt, approvedBy, owner, comment, diff, actions[{action, disabled}], history}
// IE 2026 11 03 / ODOO-5800 (webscm #128969: блокер выката — форма согласования правил по умолчанию выключена):
// команды окна формы — только допустимые по статусу и праву (как plan_action / rights бэка): Request — кто угодно, кроме утверждённого правила и уже открытой заявки;
// Approve — владелец (can_approve), правило не утверждено; Reject — владелец, правило pending с открытой заявкой либо утверждено (approved / changed);
// Withdraw — владелец, правило утверждено (approved / changed). Нет права — Approve / Reject / Withdraw скрыты, вместо них строка-причина (noRight), как в меню списка
const _reason = (h) => str(h && h.reason).replace(/^ruleApproval-/, '')
const _histDesc = (row) => (Array.isArray(row?.history) ? row.history : []).filter(isObj).slice().sort((a, b) => (str(a.at) < str(b.at) ? 1 : str(a.at) > str(b.at) ? -1 : 0))
// заявка открыта: правило pending, последнее событие решения — request
export function ruleApproval_requested(row) {
    if (!isObj(row) || ruleApproval_status(row.status) !== ST.pending) return false
    const last = _histDesc(row).find(h => ['request', 'approve', 'reject', 'withdraw'].includes(_reason(h)))
    return !!last && _reason(last) === 'request'
}
// утверждено сейчас (хранимый статус approved; changed — утверждённое и изменённое)
export function ruleApproval_isApproved(row) {
    if (!isObj(row)) return false
    const s = ruleApproval_status(row.status)
    return s === ST.approved || s === ST.changed
}
export function ruleApproval_formActions(row) {
    if (!isObj(row)) return []
    const s = ruleApproval_status(row.status), approved = ruleApproval_isApproved(row), requested = ruleApproval_requested(row)
    const out = []
    if (s !== ST.approved && !requested && !row.ruleGone) out.push('request')   // правила нет в карте — request / approve бэк отклоняет (rule_gone)
    if (row.canApprove) {
        if (s !== ST.approved && !row.ruleGone) out.push('approve')
        if (requested || approved) out.push('reject')
        if (approved) out.push('withdraw')
    }
    return out
}
export function ruleApproval_formModel(row, titles = {}) {
    if (!isObj(row)) return null
    const allowed = ruleApproval_formActions(row)   // IE 2026 11 03 / ODOO-5800 (webscm #128969: блокер выката — форма согласования правил по умолчанию выключена)
    const actions = ACTIONS.filter(a => allowed.includes(a)).map(a => ({ action: a, title: ruleApproval_actionTitle(a), icon: ICON[a], disabled: false, tooltip: '' }))   // IE 2026 11 03 / ODOO-5800 (webscm #128969: блокер выката — форма согласования правил по умолчанию выключена)
    const noRight = row.canApprove ? '' : t('Only the rule owner from the responsibles register can approve')   // IE 2026 11 03 / ODOO-5800 (webscm #128969: блокер выката — форма согласования правил по умолчанию выключена)
    return { rule: row.rule, status: row.status, text: row.text, tone: row.tone, changed: row.changed, ruleGone: row.ruleGone,
        approvedAt: ruleApproval_atText(row.approvedAt), approvedBy: row.approvedBy, owner: row.owner, ownerRole: row.ownerRole, comment: row.comment,
        diff: ruleApproval_diffRows(row.diff, titles), actions, noRight, historyCount: row.history.length }   // IE 2026 11 03 / ODOO-5800 (webscm #128969: блокер выката — форма согласования правил по умолчанию выключена): + noRight
}

// ----- история (doc.history записи RULE-APPROVAL) → единица окна History (store.approvalHistory_open) -----
function _reasonTitle(reason) {
    switch (str(reason).replace(/^ruleApproval-/, '')) {
        case 'approve': return t('Approve')
        case 'reject': return t('Reject')
        case 'request': return t('Request approval')
        case 'withdraw': return t('Withdraw approval')
        case 'changed': return t('Changed after approval')
        case 'restored': return t('Values restored')
        default: return str(reason)
    }
}
export function ruleApproval_historyUnits(row, title = '') {
    if (!isObj(row)) return []
    const events = row.history.slice().sort((a, b) => (str(a.at) < str(b.at) ? 1 : str(a.at) > str(b.at) ? -1 : 0)).map((h, i) => ({
        id: str(h.id) || row.rule + ':' + i, at: str(h.at), user_name: str(h.user), user_ref: str(h.source) === 'check' ? { system: true } : undefined, role: str(h.role), on_behalf: h.on_behalf === true,
        reason: str(h.reason), reason_title: _reasonTitle(h.reason), status_from: str(h.status_from), status_from_title: str(h.status_from) ? ruleApproval_statusText(h.status_from) : '',
        status_to: str(h.status_to), status_to_title: str(h.status_to) ? ruleApproval_statusText(h.status_to) : '', comment: str(h.comment),
        changed_periods: (Array.isArray(h.diff_fields) ? h.diff_fields : []).map(str).filter(Boolean), source: str(h.source) }))
    return [{ unit: row.record || row.rule, title: str(title) || row.rule, status: row.status, status_title: row.text, events }]
}

// ----- кэш видимых строк списка -----
export function ruleApproval_sig(segment, version, ids) { return str(segment) + '|' + str(version) + '|' + (Array.isArray(ids) ? ids.join(',') : '') }
// видимые строки списка (dataItem) → {segment, version, ids}: сегмент — из настройки списка или строк, только MAP-*
export function ruleApproval_target(items, listSegment = '', limit = LIMIT) {
    const ids = [], seen = new Set()
    let seg = str(listSegment), ver = ''
    for (const it of Array.isArray(items) ? items : []) {
        if (!isObj(it) || ids.length >= limit) continue
        const id = str(it.id)
        if (!id || seen.has(id)) continue
        if (!seg) seg = str(it.segment)
        if (str(it.segment) && seg && str(it.segment) !== seg) continue
        if (!ver) ver = str(it.version)
        seen.add(id); ids.push(id)
    }
    return { segment: ruleApproval_isMap(seg) ? seg : '', version: ver, ids: ruleApproval_isMap(seg) ? ids : [] }
}

// вызов метода виджета с колбэком ответа (как planApproval_call): ответ не применяется к виджету (command / updates сняты), actions_after — у вызывающего
export function ruleApproval_call(host, method, params, cb) {
    const store = host && host.store
    let settled = false
    const fin = (answer) => { if (settled) return; settled = true; if (typeof cb === 'function') cb(answer || null) }
    if (!store || typeof store.executeWidgetMethod !== 'function') { fin(null); return false }
    const action = { command: 'executeWidgetMethod', method, params: isObj(params) ? params : {},
        record_sendToBackend_exclude: ['_doc'], widget_sendToBackend_exclude: ['view'], no_del_last_backend_action: true,
        _response_callback: (answer) => { if (answer) { answer.command = ''; delete answer.updates } fin(answer) },
        _onResponse: (a) => { if (a === null) fin(null) }, _onAbort: () => fin(null) }
    try { store.executeWidgetMethod({ WIDGET: host.WIDGET }, action) } catch (e) { fin(null); return false }
    return true
}
// колбэк ответа команды записи (вешается на действие ruleApproval_action): actions_after забираются себе (onState), отказы — в note
export function ruleApproval_onWrite(action, opts = {}) {
    const note = typeof opts.note === 'function' ? opts.note : () => {}
    action._response_callback = (answer) => {
        const res = ruleApproval_result(answer && answer.rule_approval, opts.titleOf)
        const after = ruleApproval_afterState(answer)
        if (answer && after) answer.actions_after = (answer.actions_after || []).filter(x => !(isObj(x) && x.method === METHODS.state))
        if (res.refused.length || res.off || !answer) note(res.message, res.status)
        if (typeof opts.onState === 'function' && after) opts.onState(after)
        if (typeof opts.done === 'function') opts.done(res)
    }
    return action
}

// кнопка «Approval» панели формы правила (объект — один на виджет, как кнопка «?»): подпись — статус, цвет — тон статуса
export function ruleApproval_formButton(prev, row) {
    const b = prev || { attr_type: 'AttrButton', command: 'executeVueObjMethod', method: 'ruleApproval_formOpen', front_only: true, name: 'button-rule-approval-form', showCommandTitle: true }
    b.title = isObj(row) ? row.text : t('Approval')
    b.tooltip = t('Approval') + (isObj(row) ? ': ' + ruleApproval_pillTip(row) : '')
    b.cssClass = 'pi p-button-white pi-verified ra-btn ' + (isObj(row) ? row.tone : '')
    b.uiHelp = 'ruleApproval.formButton'
    return b
}
